import { render, staticRenderFns } from "./zcyg1-2.vue?vue&type=template&id=57ef66e0&scoped=true&"
import script from "./zcyg1-2.vue?vue&type=script&lang=js&"
export * from "./zcyg1-2.vue?vue&type=script&lang=js&"
import style0 from "./zcyg1-2.vue?vue&type=style&index=0&id=57ef66e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef66e0",
  null
  
)

export default component.exports